// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__25IP5","content":"RecentSearches_content__1-O19"};